import useIntersection from '../../../assets/hooks/useIntersection';
import './Bennefits.css';
import { BennefitsArrows, BennefitsBackBraclet, BennefitsBase, BennefitsBottomBraclet, BennefitsButtons, BennefitsDial, BennefitsFrontBracelet, BennefitsFrontBtn, BennefitsMechanism, BennefitsSmallDials } from './BennefitsIcons';

const CARDS = [
    {
        title: 'Быстрая продажа часов',
        text: `Продайте свои люксовые часы быстро и&nbsp;без лишних хлопот. Мгновенная оценка, максимальная рыночная цена и&nbsp;выплата в&nbsp;день сделки. Просто отправьте данные о&nbsp;часах&nbsp;&mdash; остальное мы&nbsp;возьмём на&nbsp;себя`,
    },
    {
        title: 'Подбор любых часов',
        text: `По&nbsp;запросу клиента мы&nbsp;подберём и&nbsp;поставим любую модель премиальных часов`,
    },
    {
        title: 'Лучшие цены',
        text: `Мы&nbsp;предлагаем выгодные цены на&nbsp;швейцарские часы, сумки и&nbsp;украшения. Благодаря экспертным знаниям рынка и&nbsp;международной сети мы&nbsp;гарантируем честные и&nbsp;конкурентные условия`,
    },
    {
        title: 'Быстрая доставка по&nbsp;всему миру',
        text: `Оперативная и&nbsp;надёжная доставка в&nbsp;любую точку мира. Где&nbsp;бы вы&nbsp;ни&nbsp;находились&nbsp;&mdash; ваша ценная вещь прибудет быстро и&nbsp;в&nbsp;полной сохранности`,
    },
    {
        title: 'Продажа через нас',
        text: `Хотите продать вещь без спешки и&nbsp;по&nbsp;максимальной цене? Мы&nbsp;сделаем всё за&nbsp;вас&nbsp;&mdash; разместим, прорекламируем и&nbsp;продадим. Вы&nbsp;получаете больше, не&nbsp;тратя времени и&nbsp;усилий`,
    },
];
function Bennefits() {
    const [bennefitsRef, isVisible] = useIntersection({ threshold: 0.6 });

    return (
        <div
            className={`bennefits ${isVisible ? 'bennefits--animate' : ''}`}
            ref={bennefitsRef}
        >
            <p className="bennefits__title">Наши преимущества</p>
            <div className='bennefits__content'>
                <div className='bennefits__cards'>
                    {CARDS.map((item, i) => (
                        <div className='bennefits__card' key={`bennefits__card${i}`}>
                            <p className='bennefits__card-title' dangerouslySetInnerHTML={{ __html: item.title }}></p>
                            <p className='bennefits__card-text' dangerouslySetInnerHTML={{
                                __html: item.text
                            }}></p>
                        </div>
                    ))}
                </div>
                <div className='bennefits__image'>
                    <BennefitsArrows mainClassName={'bennefits__arrows'} />
                    <BennefitsSmallDials mainClassName={'bennefits__small-dials'} />
                    <BennefitsDial mainClassName={'bennefits__dial'} />
                    <BennefitsBase mainClassName={'bennefits__base'} />
                    <BennefitsFrontBtn mainClassName={'bennefits__front-btn'} />
                    <BennefitsFrontBracelet mainClassName={'bennefits__front-bracelet'} />
                    <BennefitsMechanism mainClassName={'bennefits__mechanism'} />
                    <BennefitsButtons mainClassName={'bennefits__buttons'} />
                    <BennefitsBackBraclet mainClassName={'bennefits__back-bracelet'} />
                    <BennefitsBottomBraclet mainClassName={'bennefits__bottom-bracelet'} />
                </div>
            </div>
        </div>
    );
}

export default Bennefits